module.exports = __webpack_public_path__ + "static/img/Glenn-Lazarus.7272416.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Glenn-Lazarus.jpg
// module id = 2gLz
// module chunks = 0